<script setup lang="ts">
const props = defineProps({
  file: null
})
const { file } = toRefs(props)
const { rendererState } = useRenderer({ file })

onMounted(async () => {})
</script>

<template>
  <div class="renderer-container">
    <pdf-viewer
      v-if="!rendererState.loading && rendererState.objectUrl"
      :url="rendererState.objectUrl"
      class="pdf-viewer"
    />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.renderer-container
  @apply h-full w-full

.pdf-viewer
  @apply w-full h-full
  font-feature-settings: normal
</style>
